"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const Schedule_1 = __importDefault(require("@kyruus/react-ikons/Schedule"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const AvailableWithinDays = ({ availabilityDensityBest }) => {
    return (react_1.default.createElement(styles_1.AvailableWithinDaysText, { "data-testid": "profile-available-within-days" },
        react_1.default.createElement(Schedule_1.default, { size: "16px", "aria-hidden": true }),
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.availability, { values: {
                days: availabilityDensityBest
            } })),
        "*"));
};
exports.default = AvailableWithinDays;
//# sourceMappingURL=AvailableWithinDays.js.map